import { useRef, CSSProperties } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import * as css from './styles'
import { t } from '@lingui/core/macro'

interface Props {
  onSearchCallback?: (value: string) => void
  onKeyPress?: ((e: any) => void) | null
  onChange?: ((e: any) => void) | null
  searchBoxStyles?: CSSProperties
  inputBoxStyles?: CSSProperties
}

export const Search = ({
  onSearchCallback,
  onChange = null,
  onKeyPress = null,
  searchBoxStyles = {},
  inputBoxStyles = {},
}: Props) => {
  const searchRef = useRef<HTMLInputElement>(null)

  return (
    <css.SearchBox style={searchBoxStyles}>
      <css.InputContainer onClick={() => searchRef?.current?.focus()} style={inputBoxStyles}>
        <SearchIcon css={css.icon} />
        <input
          css={css.input}
          name="search"
          onKeyDown={e => {
            if (!onSearchCallback) {
              onKeyPress?.(e)
            }
          }}
          onChange={e => {
            if (onSearchCallback) {
              onChange?.(e)
            }
          }}
          placeholder={t`Search (enter)`}
          ref={searchRef}
        />
      </css.InputContainer>
    </css.SearchBox>
  )
}
